'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SingleAppUser(details, application, impersonatedBy) {
  this.ha = null;
  this.rK = null;
  this.L0 = null;
  this.ha = details;
  this.rK = application;
  this.L0 = impersonatedBy;
}
export { $c_Lpresto_types$SingleAppUser as $c_Lpresto_types$SingleAppUser };
$p = $c_Lpresto_types$SingleAppUser.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SingleAppUser;
/** @constructor */
function $h_Lpresto_types$SingleAppUser() {
}
export { $h_Lpresto_types$SingleAppUser as $h_Lpresto_types$SingleAppUser };
$h_Lpresto_types$SingleAppUser.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$SingleAppUser)) {
    var x = this.ha;
    var x$2 = x$0.ha;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.rK;
      var x$4 = x$0.rK;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.L0;
      var x$6 = x$0.L0;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "SingleAppUser";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.ha;
      break;
    }
    case 1: {
      return this.rK;
      break;
    }
    case 2: {
      return this.L0;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$SingleAppUser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kb)));
}
export { $isArrayOf_Lpresto_types$SingleAppUser as $isArrayOf_Lpresto_types$SingleAppUser };
var $d_Lpresto_types$SingleAppUser = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SingleAppUser, "presto.types$SingleAppUser", ({
  kb: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$SingleAppUser as $d_Lpresto_types$SingleAppUser };
//# sourceMappingURL=presto.types$-Single-App-User.js.map
